import { useTranslation } from "react-i18next";
import { toMarketingLang } from "@/lib/langRoutes";

export const useMarketingT = () => {
  const { i18n } = useTranslation();
  // Marketing pages only exist in ar/en/fr; any other UI language (e.g. ur)
  // falls back to Arabic so route prefixes and content stay valid.
  const lang = toMarketingLang(i18n.language);
  const t = (ar: string, en: string, fr: string) =>
    lang === "en" ? en : lang === "fr" ? fr : ar;
  const pick = <T extends Record<string, any>>(row: T, base: string): string =>
    (row?.[`${base}_${lang}`] || row?.[`${base}_ar`] || "") as string;
  return { t, pick, lang };
};
